import { InitialPageParam, infiniteQueryOptions } from 'src/app/helpers/redux.helper';
import { apiSlice } from 'src/app/redux/api/apiSlice';
import {
  GeneralReport,
  GeneralReportCreateType,
  GeneralReportDownloadDataType,
  GeneralReportDownloadFilesDataType,
  GeneralReportDownloadResultType,
  GeneralReportLookupDataType,
  GeneralReportLookupResultType,
  GeneralReportRefreshDataType,
  GeneralReportRefreshResultType,
  GeneralReportViewDataType,
} from 'src/app/redux/generalReports/general-reports-slice.type';
import { finalUrlsConfig } from 'src/configs/url.config';

export const generalReportsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getGeneralReports: builder.infiniteQuery<
      GeneralReportLookupResultType,
      GeneralReportLookupDataType | void,
      InitialPageParam
    >({
      infiniteQueryOptions,
      query: ({ pageParam, queryArg }) => {
        return {
          url: finalUrlsConfig().generalReports.lookup,
          params: {
            ...pageParam,
            ...queryArg,
          },
        };
      },
      providesTags: [{ type: 'GeneralReports', id: 'LIST' }],
    }),
    downloadGeneralReport: builder.mutation<GeneralReportDownloadResultType, GeneralReportDownloadDataType>({
      query: (data) => ({
        url: finalUrlsConfig().generalReports.download,
        body: data,
        method: 'POST',
      }),
    }),
    createGeneralReport: builder.mutation<GeneralReport, GeneralReportCreateType>({
      query: (data) => ({
        url: finalUrlsConfig().generalReports.create,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'GeneralReports', id: 'LIST' }],
    }),
    deleteGeneralReport: builder.mutation<void, string>({
      query: (id: string) => ({
        url: `${finalUrlsConfig().generalReports.delete}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [{ type: 'GeneralReports', id: 'LIST' }],
    }),
    refreshGeneralReport: builder.mutation<GeneralReportRefreshResultType, GeneralReportRefreshDataType>({
      query: (data) => ({
        url: finalUrlsConfig().generalReports.refresh,
        body: data,
        method: 'POST',
      }),
    }),
    viewGeneralReport: builder.mutation<string, GeneralReportViewDataType>({
      query: (data) => ({
        url: finalUrlsConfig().generalReports.view,
        body: data,
        method: 'POST',
        responseHandler: 'text',
      }),
    }),
    downloadFilesGeneralReport: builder.mutation<any, GeneralReportDownloadFilesDataType>({
      query: (data) => ({
        url: finalUrlsConfig().generalReports.downloadFiles,
        body: data,
        method: 'POST',
        responseHandler: 'text',
      }),
    }),
  }),
});

export const {
  useCreateGeneralReportMutation,
  useGetGeneralReportsInfiniteQuery,
  useDownloadGeneralReportMutation,
  useDeleteGeneralReportMutation,
  useRefreshGeneralReportMutation,
  useViewGeneralReportMutation,
  useDownloadFilesGeneralReportMutation,
} = generalReportsApiSlice;
